module.exports = __webpack_public_path__ + "img/TSGFrischwasser.a42709bc.png";